import React from "react";

function Terms() {
  return (
    <main className="page">
      <article className="panel terms-doc">
        <h1>Terms &amp; Conditions</h1>
        <p className="terms-doc__effective">
          <strong>Effective Date:</strong> 22 April 2026
        </p>

        <p>
          Welcome to WillPlay. By accessing or using WillPlay (“Platform,” “we,” “our,” or “us”), you agree to these Terms
          &amp; Conditions (“Terms”). If you do not agree, do not use the Platform.
        </p>

        <section className="terms-doc__section">
          <h2>1. Platform Nature</h2>
          <p>
            WillPlay is only a technology platform that helps users discover, create, host, and join sports matches and
            tournaments. WillPlay does not organize, manage, supervise, operate, or guarantee any match or tournament.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>2. User Responsibility</h2>
          <p>
            Each user is solely responsible for their own conduct, participation, attendance, communication, and decisions
            made through the Platform.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>3. Organizer / Host Responsibility</h2>
          <p>The user who creates or hosts a match or tournament is solely responsible for:</p>
          <ul className="terms-list">
            <li>
              Selecting and arranging the venue, schedule, format, rules, equipment, and any fees or costs (which must be
              handled outside the Platform unless we expressly enable payments in future).
            </li>
            <li>
              The safety and suitability of the activity, compliance with applicable laws, permits, and venue policies,
              and ensuring participants understand any risks involved in sports participation.
            </li>
            <li>
              The accuracy of listings (including location and timing) and for communicating changes, cancellations, or
              postponements to participants in a timely manner.
            </li>
            <li>
              Conduct at the event and resolving disputes that arise among participants; WillPlay is not a party to those
              arrangements.
            </li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>4. No Endorsement; Third Parties</h2>
          <p>
            References to venues, maps, or other users are for convenience only. WillPlay does not endorse any user,
            venue, or event. Third-party services (such as maps) may apply their own terms.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>5. Limitation of Platform Liability</h2>
          <p>
            To the maximum extent permitted by law, WillPlay is not liable for injuries, losses, disputes, cancellations,
            no-shows, or conduct occurring off the Platform or at any real-world event. The Platform is provided “as is”
            without warranties beyond what the law requires.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>6. Accounts &amp; Acceptable Use</h2>
          <p>
            You must provide accurate registration information, keep credentials secure, and not misuse chat, messaging, or
            other features. We may suspend or terminate accounts that violate these Terms or put users at risk.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>7. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. Continued use of the Platform after changes constitutes acceptance
            of the updated Terms. Material updates will be posted on the Platform.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>8. Governing Law</h2>
          <p>These Terms are governed by the laws of India, without regard to conflict-of-law principles.</p>
        </section>

        <section className="terms-doc__section">
          <h2>9. Contact</h2>
          <p>
            Questions about these Terms:{" "}
            <a href="mailto:support@willplay.in">support@willplay.in</a>
          </p>
        </section>
      </article>
    </main>
  );
}

export default Terms;
